import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Card, CardHeader, CardBody, Row, Col, Button, Label, FormGroup } from 'reactstrap'
import { bindActionCreators } from 'redux';
import MediaQuery from 'react-responsive'
import { getOffer } from '../../../../store/offer/actions'
import * as columns from './_columns'
import { formatHelper } from '../../../../common/helpers';
import { arrayIsNullOrEmpty } from '../../../../common/helpers/validation';
import { layout } from '../../../../common/constants'
import { DataTable, MainLoader } from '../../../../components'

class OfferDetail extends Component {

    componentDidMount() {
        this.props.getOffer(this.props.match.params.id)
    }

    componentWillUnmount() {
        //TODO: Add reset offer detail
    }

    renderField(label, value) {
        return (
            <FormGroup row>
                <Col md='2' lg='1'>
                    <Label color='red'>{label}</Label>
                </Col>
                <Col xs='12' md='5'>
                    <p className="form-control-static">{value}</p>
                </Col>
            </FormGroup>

        )
    }
    renderImageField(label, value) {
        return (
            <FormGroup row>
                <Col md='2' lg='1'>
                    <Label color='red'>{label}</Label>
                </Col>
                <Col xs="12" md="4">
                    {
                        value && <img src={value} style={{ maxHeight: 200 }} />
                    }
                </Col>
            </FormGroup>
        )
    }
    renderFields() {
        const offer = this.props.offer
        return (
            <div>
                {this.renderField('Nombre Oferta:', offer.name)}
                {this.renderImageField('Imagen:', offer.imageUrl)}
                {this.renderField('Fecha de Inicio:', formatHelper.toDateDDMMYYY(offer.startDate))}
                {this.renderField('Fecha de Expiracion:', formatHelper.toDateDDMMYYY(offer.expirationDate))}
                {this.renderField('Precio Total:', offer.total_price)}
            </div>
        )
    }

    renderDataTable(columns, data) {
        return (
            <DataTable
                data={data}
                keyField='id'
                columns={columns}
                loading={this.props.loading}
            />
        )
    }
    renderProductsTable(offer) {
        return (< Row >
            <Col >
                <MediaQuery maxWidth={layout.XS_MAX_WIDTH} >
                    {this.renderDataTable(columns.columnsProductXS, offer.Offer_products)}
                </MediaQuery>
                <MediaQuery minWidth={layout.SM_MIN_WIDTH} maxWidth={layout.MD_MAX_WIDTH} >
                    {this.renderDataTable(columns.columnsProductSM, offer.Offer_products)}
                </MediaQuery>
                <MediaQuery minWidth={layout.LG_MIN_WIDTH} >
                    {this.renderDataTable(columns.columnsProduct, offer.Offer_products)}
                </MediaQuery>

            </Col>
        </Row>)
    }
    renderServicesTable(offer) {
        return (
            <Row>
                <Col >
                    <MediaQuery maxWidth={layout.XS_MAX_WIDTH} >
                        {this.renderDataTable(columns.columnsServiceXS, offer.Offer_services)}
                    </MediaQuery>
                    <MediaQuery minWidth={layout.SM_MIN_WIDTH} maxWidth={layout.MD_MAX_WIDTH} >
                        {this.renderDataTable(columns.columnsServiceSM, offer.Offer_services)}
                    </MediaQuery>
                    <MediaQuery minWidth={layout.LG_MIN_WIDTH} >
                        {this.renderDataTable(columns.columnsService, offer.Offer_services)}
                    </MediaQuery>

                </Col>
            </Row>
        )
    }
    renderBothTables(offer) {
        return (
            <Row>
                {this.renderProductsTable(offer)}
                {this.renderServicesTable(offer)}
            </Row>
        )
    }

    renderTables(products, services, offer) {

        if (arrayIsNullOrEmpty(products) && arrayIsNullOrEmpty(services)) {
            return (
                this.renderBothTables(offer)
            )
        } else if (arrayIsNullOrEmpty(products) && !arrayIsNullOrEmpty(services)) {
            return (this.renderProductsTable(offer))
        } else if (arrayIsNullOrEmpty(services) && !arrayIsNullOrEmpty(products)) {
            return (this.renderServicesTable(offer))
        } else {
            return (<div></div>)
        }
    }
    render() {
        const { offer, loading, error } = this.props
        if (loading) {
            return <MainLoader />
        }
        return (

            <div className="animated">

                <Card>
                    <CardHeader>
                        Detalle de Oferta
                    </CardHeader>
                    {offer && (
                        <CardBody>
                            {this.renderFields()}
                            {
                                this.renderTables(offer.Offer_products, offer.Offer_services, offer)
                            }
                            <Row>
                                <Col className='mt-3'>
                                    <Button color='secondary' onClick={() => this.props.history.push('/administration/offers')} ><i className="fa fa-chevron-left mr-1" /> Volver</Button>
                                </Col>
                            </Row>
                        </CardBody>
                    )}

                </Card>
            </div >
        )
    }
}

function mapStateToProps(state) {
    const { offer, error, loading } = state.offer.offerList

    return {
        offer,
        error,
        loading,
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getOffer,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(OfferDetail)


// WEBPACK FOOTER //
// ./src/scenes/Administration/Offer/OfferDetail/OfferDetail.js